import { render, staticRenderFns } from "./TrendingCharts.vue?vue&type=template&id=b803cdb4&"
import script from "./TrendingCharts.vue?vue&type=script&lang=js&"
export * from "./TrendingCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b803cdb4')) {
      api.createRecord('b803cdb4', component.options)
    } else {
      api.reload('b803cdb4', component.options)
    }
    module.hot.accept("./TrendingCharts.vue?vue&type=template&id=b803cdb4&", function () {
      api.rerender('b803cdb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/TrendingCharts.vue"
export default component.exports